var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#f4f3f0",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.74 10.491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.228,9.228,0,18.455,9.228,9.228,0,0,9.228,9.228,18.455,0,9.228,9.228l9.228,9.228Z",
    transform: "translate(2.936 4.281)",
    fill: "#f4f3f0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2598.436-634.5a1.281,1.281,0,0,1,.909.377l8.319,8.319,8.319-8.319a1.285,1.285,0,0,1,1.818,0,1.282,1.282,0,0,1,.377.909,1.282,1.282,0,0,1-.377.909l-8.318,8.319,8.318,8.319a1.282,1.282,0,0,1,.377.909,1.282,1.282,0,0,1-.377.909,1.285,1.285,0,0,1-1.818,0l-8.319-8.319-8.319,8.319a1.285,1.285,0,0,1-1.818,0,1.282,1.282,0,0,1-.377-.909,1.282,1.282,0,0,1,.377-.909l8.318-8.319-8.318-8.319a1.282,1.282,0,0,1-.377-.909,1.282,1.282,0,0,1,.377-.909A1.281,1.281,0,0,1,2598.436-634.5Z",
    transform: "translate(-2595.5 637.5)",
    fill: "#816920"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.51a38159.svg";
export { ForwardRef as ReactComponent };